import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        // Configuration pour l'authentification par email
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,

        // Configuration des emails
        redirectTo: `${window.location.origin}/dashboard`,
        emailRedirectTo: `${window.location.origin}/dashboard`,
    }
})

// Fonction helper pour vérifier la connexion
export const checkSupabaseConnection = async () => {
    try {
        const { error } = await supabase.from('_supabase_migrations').select('*').limit(1)
        if (error && error.code !== 'PGRST116') { // PGRST116 = table not found, c'est normal
            console.warn('Supabase connection issue:', error)
            return false
        }
        console.log('✅ Supabase connected successfully')
        return true
    } catch (err) {
        console.error('❌ Supabase connection failed:', err)
        return false
    }
}